import React from 'react';

export const Button = ({ children, variant = 'primary', className = '', href, ...props }) => {
  const baseStyle = "inline-flex items-center justify-center px-8 py-4 rounded-full font-medium tracking-wide transition-all duration-300 text-sm md:text-base uppercase tracking-widest cursor-pointer";
  
  const variants = {
    primary: "bg-olive-grove text-vintage-white hover:bg-olive-grove/90 shadow-[0_4px_14px_0_rgba(110,116,81,0.39)] hover:shadow-[0_6px_20px_rgba(110,116,81,0.23)] hover:-translate-y-0.5",
    secondary: "bg-white text-deep-charcoal border border-warm-stone hover:border-estate-bronze hover:text-estate-bronze shadow-sm hover:shadow-md",
    outline: "bg-transparent border border-estate-bronze text-estate-bronze hover:bg-estate-bronze hover:text-white",
  };

  const Tag = href ? 'a' : 'button';

  return (
    <Tag 
      href={href} 
      className={`${baseStyle} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
};